import ClockSolid from './ClockSolid'

export default ClockSolid
// eslint-disable-next-line import/export
export * from './ClockSolid'
